import ApiRequestBuilder from '../ApiService/Request/ApiRequestBuilder';


const API_PATH_MY_BASE = '/my';

const API_PATH_MY_CONTENTS_BASE = `${API_PATH_MY_BASE}/contents`;

const API_PATH_MY_CONTENT_ADD_ENTITY = `${API_PATH_MY_CONTENTS_BASE}/add/entity`;
const API_PATH_MY_CONTENTS_LIST = API_PATH_MY_CONTENTS_BASE;
const API_PATH_MY_CONTENT_DISTRIBUTIONS = `${API_PATH_MY_CONTENTS_BASE}/distributions`;
const API_PATH_MY_CONTENT_SET_STATUS = `${API_PATH_MY_CONTENTS_BASE}/status`;

const API_PATH_MY_IMPORT_BASE = `${API_PATH_MY_BASE}/import`;
const API_PATH_MY_IMPORT_JOBS_BASE = `${API_PATH_MY_IMPORT_BASE}/jobs`;
const API_PATH_MY_IMPORT_JOB_DETAILS = `${API_PATH_MY_IMPORT_JOBS_BASE}/{jobId}`;

const API_PATH_MY_ORDERS_LIST = `${API_PATH_MY_BASE}/orders`;
const API_PATH_MY_ORDERS_DOWNLOAD_TRANSACTION_RECEIPTS_BUYER = `${API_PATH_MY_ORDERS_LIST}/{orderId}/transactions/receipt`;


class MyService {

    /**
     * @type {ApiService}
     */
    apiService;


    /**
     * @param apiService {ApiService}
     */
    constructor(apiService) {

        this.apiService = apiService;
    }


    /**
     * @param queryParams {object} List request for my content
     * @return {Promise<object>}
     */
    async getMyContents(queryParams) {

        const myContentsApiRequest = ApiRequestBuilder.get(API_PATH_MY_CONTENTS_LIST)
            .withToken()
            .queryParams(queryParams)
            .build();

        return this.apiService.executeOrFail(myContentsApiRequest, 'Error getting my contents');
    }


    /**
     * @param queryParams {object} List request for my orders
     * @return {Promise<ApiResponse>}
     */
    async getMyOrders(queryParams) {

        const myOrdersApiRequest = ApiRequestBuilder.get(API_PATH_MY_ORDERS_LIST)
            .withToken()
            .queryParams(queryParams)
            .build();

        return this.apiService.executeOrFail(myOrdersApiRequest, 'Error getting my orders');
    }


    /**
     * @param orderId {string} Order id to download buyer invoices for
     * @return {ApiRequest} Download order buyer invoices API request
     */
    createOrderBuyerTransactionReceiptDownloadRequest(orderId) {

        return ApiRequestBuilder.get(API_PATH_MY_ORDERS_DOWNLOAD_TRANSACTION_RECEIPTS_BUYER)
            .pathParams({orderId})
            .withToken()
            .build();
    }


    /**
     * @param contents {array|object[]} Content entities to add
     * @return {Promise<object>}
     */
    async addContentEntities(contents) {

        const saveContentApiRequest = ApiRequestBuilder.post(API_PATH_MY_CONTENT_ADD_ENTITY)
            .withToken()
            .json()
            .body({
                contents
            })
            .build();

        return this.apiService.executeOrFail(saveContentApiRequest, 'Error adding content entity');
    }


    /**
     * Sets the status for the given content ids
     *
     * @param contentIds {array|string[]} List of content ids to set status for
     * @param newStatus {string} New status
     * @return {Promise<object>} Updated contents count
     */
    async setContentStatus(contentIds, newStatus) {

        const setContentStatusApiRequest = ApiRequestBuilder.post(API_PATH_MY_CONTENT_SET_STATUS)
            .withToken()
            .json()
            .body({
                contentIds,
                newStatus
            })
            .build();

        return this.apiService.executeOrFail(setContentStatusApiRequest, 'Error setting content status');
    }


    /**
     * @param contentIds {array|string[]} Content ids to get distributions for
     * @returns {Promise<object>} Content distributions response
     */
    async getContentDistributions(contentIds) {

        const apiRequest = ApiRequestBuilder.post(API_PATH_MY_CONTENT_DISTRIBUTIONS)
            .withToken()
            .json()
            .body({contentIds})
            .build();

        return this.apiService.executeOrFail(apiRequest, 'Error getting content distributions');
    }


    /**
     * @param contentIds {array|string[]} Content ids to get distributions for
     * @param distribution {object} Content distribution
     * @returns {Promise<object>} Content distributions response
     */
    async setContentDistributions(contentIds, distribution) {

        const apiRequest = ApiRequestBuilder.put(API_PATH_MY_CONTENT_DISTRIBUTIONS)
            .withToken()
            .json()
            .body({contentIds, distribution})
            .build();

        return this.apiService.executeOrFail(apiRequest, 'Error setting content distributions');
    }


    /**
     * @param jobId {string} Job id to get job details for
     * @return {Promise<ApiResponse>}
     */
    async getJobDetails(jobId) {

        const jobDetailsApiRequest = ApiRequestBuilder.get(API_PATH_MY_IMPORT_JOB_DETAILS)
            .pathParams({jobId})
            .withToken()
            .json()
            .build();

        return this.apiService.execute(jobDetailsApiRequest);
    }
}

export default MyService;
